export default __webpack_public_path__ + "static/media/PendingGrey.34eedde3.svg";